export const types =  {
    GenerateWords: 'GenWors',
    RemoveWords : 'Remove-words',
}